/*
 *CPJRS 07/26/2022 PR Intertext Project : Provide feature for Registration & Sign-in 
 */
export default function isValidString(value){
    return !(value == undefined || value == null || value == '')
}